import React from "react";
import ChangeColor from "../ChangeColor";

/** `size` is passed by viewer-modals' BasicControls but ignored here — this icon sizes off `height`. */
type MeasurementProps = {
  color?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  height?: number;
  size?: number;
};

function Measurement({ color, onClick, height }: Readonly<MeasurementProps>) {
  const iconHeight = height || 22;
  return (
    <div>
      <svg
        onClick={onClick}
        width="24"
        height={iconHeight}
        viewBox="0 0 24 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <linearGradient id="Measurement" gradientTransform="rotate(45)">
          <stop offset="38%" stopColor={color} />
          <stop offset="92%" stopColor={ChangeColor(color)} />
        </linearGradient>
        <path
          d="M16 16H13M16 6H13M13 11H23M23 11L21 13M23 11L21 9M1 11L3 9M1 11L3 13M1 11H8M15.4 21H8.6C8.52121 21 8.44319 20.9845 8.37039 20.9543C8.29759 20.9242 8.23145 20.88 8.17574 20.8243C8.12002 20.7685 8.07583 20.7024 8.04567 20.6296C8.01552 20.5568 8 20.4788 8 20.4V1.6C8 1.44087 8.06321 1.28826 8.17574 1.17574C8.28826 1.06321 8.44087 1 8.6 1H15.4C15.5591 1 15.7117 1.06321 15.8243 1.17574C15.9368 1.28826 16 1.44087 16 1.6V20.4C16 20.5591 15.9368 20.7117 15.8243 20.8243C15.7117 20.9368 15.5591 21 15.4 21Z"
          stroke='url("#Measurement")'
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

export default Measurement;
